// English translations
export const en = {
  // Navigation
  nav: {
    products: 'Products',
    sampleGalleries: 'Sample Galleries',
    resources: 'Resources',
    pricing: 'Pricing',
    startFree: 'START FREE',
    login: 'Login',
    lang: 'ENG',
  },
  
  // Products dropdown
  productsMenu: [
    { label: 'Client Galleries', href: '#galleries' },
    { label: 'Print Store', href: '#store' },
    { label: 'Marketing Automations', href: '#automation' },
    { label: 'Slideshows', href: '#slideshows' },
    { label: 'Blogs', href: '#blogs' },
    { label: 'Video Delivery', href: '#video' },
    { label: 'AI Gallery Search', href: '#ai-search' },
    { label: 'Vendor Network', href: '#vendor' },
  ],
  
  // Resources dropdown
  resourcesMenu: [
    { label: 'Pic-Time Blog', href: '#' },
    { label: 'Gallery Migration', href: '#migration' },
    { label: 'Simple Sales System', href: '#' },
    { label: 'Affiliate Program', href: '#' },
    { label: 'Help Center', href: '#' },
    { label: 'Experts Hub', href: '#' },
    { label: 'Webinars', href: '#' },
  ],
  
  // Hero section
  hero: {
    title: 'Elevate Your Photography',
    titleLine2: 'to a Successful Business',
    features: ['Galleries', 'Print Store', 'Marketing Automations', 'Slideshows', 'Blogs', 'AI Search'],
    cta: 'START FOR FREE',
  },
  
  // Client Galleries section
  clientGalleries: {
    title: 'Client Galleries',
    subtitle: 'Your Brand Deserves the Best',
    tryNow: 'Try it Now',
    slides: [
      {
        title: 'Exceptional Aesthetic',
        description: 'Beautiful client galleries to deliver, share and sell your images. Craft your client\'s journey with unique photo grids that provide an edge to your storytelling and enhance your brand experience online.',
      },
      {
        title: 'Video & GIFs',
        description: 'Add another dimension to your galleries with video and GIF integration. Videos can be added as a scene and GIFs can be uploaded in the gallery and even set as the cover.',
      },
      {
        title: 'In Your Language',
        description: 'Pic-Time offers a variety of languages, all reviewed by local area photographers. Make your galleries a familiar space for clients by adjusting the default language for individual projects.',
      },
      {
        title: 'Portfolio',
        description: 'Clients can directly login to their galleries, while visitors have access to public or selected sneak peek galleries. Portfolio pages are fully customizable and can be easily integrated into your site.',
      },
      {
        title: 'Mobile',
        description: 'The features you love, on every device. With quick loading even for the largest galleries, clients can easily share, shop, and download images on the go.',
      },
    ],
  },
  
  // Video Delivery section
  videoDelivery: {
    title: 'Video Delivery',
    description: 'Upload videos of up to 90-min in HD or 4K, create an immersive gallery experience with short clips alongside your photos, deliver social media-ready content in a dedicated scene, and increase your video storage as your business grows.',
    cta: 'Explore Video Delivery',
    clickForSound: 'Click for sound',
  },
  
  // Vendor Network section
  vendorNetwork: {
    title: 'Vendor Network',
    description: 'Build strong connections and grow your brand as part of your workflow. Collect vendor contacts, share AI-curated vendor galleries, and ensure proper use with usage terms attached to each gallery.',
    cta: 'Learn more',
    galleryReady: 'YOUR VENDOR GALLERY IS READY',
    viewGallery: 'VIEW GALLERY',
    photos: 'photos',
  },
  
  // AI Search section
  aiSearch: {
    title: 'AI Gallery Search',
    description: 'The next generation of professional gallery delivery! Give clients the best experience with an interactive search bar allowing them to quickly and easily find their favorite moments with their favorite people.',
    cta: 'Learn more',
    searchPlaceholder: 'Search for moments...',
    peopleDetected: 'people detected',
  },
  
  // Smart Store section
  smartStore: {
    title: 'Smart Store',
    description: 'Offer your clients a wide range of quality printed goods, previewed with images they engage with the most in their gallery.',
    cta: 'Learn More',
    products: [
      { name: 'LAY FLAT ALBUMS' },
      { name: 'MATTED FRAMES' },
      { name: 'CALENDARS' },
      { name: 'PRINTS' },
      { name: 'PRINT BOX' },
      { name: 'GREETING CARDS' },
    ],
  },
  
  // Print Labs section
  printLabs: {
    title: 'Worldwide Print Labs',
    description: 'Choose from our international print lab partners, seamlessly integrated into your print store.',
    cta: 'Learn More',
  },
  
  // Marketing Automation section
  marketingAutomation: {
    title: 'Marketing Automation',
    description: 'Getting your clients to print their photos is an important goal for photographers. Each of our readymade campaigns includes a set of discounted emails and banners designed to connect with your clients and grow your print sales.',
    cta: 'Learn More',
    clickForSound: 'Click for sound',
  },
  
  // Album Builder section
  albumBuilder: {
    title: 'Album Builder',
    description: 'Design, sell, and order albums directly from the gallery, or let your clients get hands-on with the design process to make it even easier. Enjoy an efficient workflow from design to ordering and shipping.',
    cta: 'Learn More',
    includedInPro: 'Included in pro plans',
    albumOptions: [
      { name: 'Wedding Day', count: 45 },
      { name: 'Time to Celebrate', count: 32 },
      { name: 'Hidden Photos', count: 18 },
      { name: 'My Favorites', count: 56 },
      { name: 'Wedding Album', count: 40 },
    ],
  },
  
  // Slideshows section
  slideshows: {
    title: 'Slideshows',
    description: 'Elevate your delivery and create an emotional experience with Slideshows, built right into our Client Galleries. Enjoy a licensed music library of over 1800 tracks, including automatic beat matching and advanced design tools.',
    cta: 'Explore Slideshows',
    includedInPro: 'Included in pro plans',
    tracks: '1800+ tracks',
    clickForSound: 'Click for sound',
  },
  
  // Blogs section
  blogs: {
    title: 'Blogs',
    description: 'Our blog editor is an effective storytelling tool built to enhance your online presence as part of your website or as a standalone page. Easily create SEO-optimized blog posts with advanced design tools and promote them on social media.',
    cta: 'Explore Blogs',
    includedInPro: 'Included in pro plans',
    blogEditor: 'Blog Editor',
    seoOptimized: 'SEO Optimized',
    clickForSound: 'Click for sound',
  },
  
  // Art Galleries section
  artGalleries: {
    title: 'Art Galleries',
    subtitle: 'Your Online Exhibition and Print Store',
    includedInPro: 'Included in pro plans',
    cta: 'Explore Art Galleries',
    slides: [
      {
        title: 'Art Gallery & Store',
        description: 'The Art Gallery is a dedicated platform for creatives with a range of tools dedicated for selling art including limited editions, video and audio notes, worldwide labs integration and a built-in marketing Automation.',
      },
      {
        title: 'Design Your Space',
        description: 'Galleries are fully customizable so you can let your voice as an artist be heard. Also, you can display your products in an interior setting so that clients can better conceptualize the size and feel of the piece.',
      },
      {
        title: 'Automated Order to Delivery',
        description: 'Our worldwide network of print labs provides a seamless production process where clients can order and ship independently. Enjoy a variety of quality print products from Fine Art Prints and Matted Frames to Canvases and Metal Prints.',
      },
    ],
  },
  
  // CRM Integrations section
  crmIntegrations: {
    title: 'CRM Integrations',
    description: 'We\'ve partnered with a variety of studio management systems including HoneyBook, Studio Ninja, Light Blue, and Iris Works to integrate our data seamlessly. Easily manage, track and organize client relationships and accounting to streamline your workflow.',
    cta: 'Learn More',
  },
  
  // Migration section
  migration: {
    title: 'Easily Move Your Galleries',
    description: 'Switching platforms is easy – our migration team does it for you! Our team will transfer all your photos and client information from your current gallery service to Pic-Time.',
    cta: 'Learn More',
    migrationComplete: 'Migration Complete',
    photosTransferred: 'photos transferred',
  },
  
  // CTA section
  cta: {
    title: 'Join Pic-Time Today',
    description: 'Try Pic-Time\'s Advanced plan FREE for 30 days. No credit card required.',
    button: 'Start for Free',
    noCreditCard: 'No credit card required.',
  },
  
  // Login page
  login: {
    title: 'Access Your Gallery',
    subtitle: 'Enter the credentials provided by your photographer',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password',
    submit: 'Login',
    loading: 'Logging in...',
    errorRequired: 'Please enter username and password',
    backHome: '← Back to home',
  },
  
  // Footer
  footer: {
    product: {
      title: 'PRODUCT',
      links: [
        { label: 'Print Store', href: '#' },
        { label: 'AI-Powered Gallery Search', href: '#' },
        { label: 'Video Delivery', href: '#' },
        { label: 'Sales Automations', href: '#' },
        { label: 'Sample Galleries', href: '#' },
        { label: 'Art Galleries', href: '#' },
        { label: 'Blogs', href: '#' },
        { label: 'Slideshows', href: '#' },
      ],
    },
    resources: {
      title: 'RESOURCES',
      links: [
        { label: 'Pic-Time Blog', href: '#' },
        { label: 'Gallery Migration', href: '#' },
        { label: 'Simple Sales System', href: '#' },
        { label: 'Affiliate Program', href: '#' },
        { label: 'Help Center', href: '#' },
        { label: 'Experts Hub', href: '#' },
        { label: 'Webinars', href: '#' },
      ],
    },
    company: {
      title: 'COMPANY',
      links: [
        { label: 'Pricing', href: '#' },
        { label: 'About Us', href: '#' },
        { label: 'Careers', href: '#' },
        { label: 'Contact', href: '#' },
      ],
    },
    followUs: 'FOLLOW US',
    copyright: '© 2025 Pic-Time, all rights reserved.',
    legal: [
      { label: 'Terms Of Service', href: '#' },
      { label: 'Privacy Policy', href: '#' },
      { label: 'DPA', href: '#' },
      { label: 'CCPA', href: '#' },
      { label: 'AI Terms', href: '#' },
    ],
    downloadOn: 'Download on the',
    appStore: 'App Store',
    getItOn: 'Get it on',
    googlePlay: 'Google Play',
  },
};
